import React from "react";
import { useCssStyle } from "../../customHook/getCssStyle";
import { ImageBackground, View } from "react-native";
import Loader from "../../components/Loader/loader";
import { CUSTOM_PRELOADER_IMG, CUSTOM_PRELOADER_LOADER, CUSTOM_PRELOADER_VIDEO } from "../../assets";
import { VideoHandler } from "../../components/videoComp/video";
import LottieView from "lottie-react-native";


export const CustomPreLoader = () => {

    const getStyles = useCssStyle();


    return CUSTOM_PRELOADER_VIDEO ? (
        <View style={getStyles(['preLoaderContainer'])} id='preLoaderContainer' >
            <VideoHandler
                // posterSrc={CUSTOM_PRELOADER_IMG}
                videoSrc={CUSTOM_PRELOADER_VIDEO}
                style={getStyles(['welcomeScreenVideo'])}
                id='welcomeScreenVideo'
            />
            {CUSTOM_PRELOADER_LOADER ?
                <LottieView
                    source={CUSTOM_PRELOADER_LOADER}
                    style={getStyles(['preLoader_Loaderlottie'])}
                    autoPlay
                    loop={true}
                />
                : <Loader style={getStyles(['preLoader_Loader'])} />
            }
        </View>
    ) : (
        <ImageBackground
            source={CUSTOM_PRELOADER_IMG}
            style={getStyles(['preLoaderContainer'])}
            resizeMode="cover"
        >
            {CUSTOM_PRELOADER_LOADER ?
                <LottieView
                    source={CUSTOM_PRELOADER_LOADER}
                    style={getStyles(['preLoader_Loaderlottie'])}
                    autoPlay
                    loop={true}
                />
                : <Loader style={getStyles(['preLoader_Loader'])} />
            }
        </ImageBackground>
    )
}